import { isSameDay } from "./date.util";
export var findRateByDate = function (rates, reservationStartTime) {
    return (rates === null || rates === void 0 ? void 0 : rates
    // First try to find a rate that matches the reservation start time
    .find(function (sr) { return sr.startTime <= reservationStartTime
        && sr.endTime >= reservationStartTime; }))
        // Then try to find a rate that starts during the same day as the reservation start time
        || (rates === null || rates === void 0 ? void 0 : rates.find(function (sr) { return isSameDay(sr.startTime, reservationStartTime); }))
        // Finally, return the first rate as a fallback
        || (rates === null || rates === void 0 ? void 0 : rates[0]);
};
